import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

const Frame = styled.div`
  width:100%;
  height:100%;
  display:flex;
  flex-direction:column;
  justify-content: center;
  align-items: center;
  position:absolute;
  background-color:blue;
`;

const Introduction1 = () => (
  <Frame>
    <div>
      설명페이지 1
    </div>
    <div>
      <Link to='/introduction2'>
        <button>
          다음
        </button>
      </Link>
    </div>
  </Frame>
);

export default Introduction1;